import axios from "axios";
import { Base_URL } from "../url";

// Fetch all resources for dropdown
export const fetchAllResources = async () => {
  try {
    const response = await axios.get(`${Base_URL}/SalaryProcess/ResourceMasters`);
    return response.data.map(resource => ({
      value: resource.resourceId,
      label: `${resource.resourceId} - ${resource.name}`
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching resources!";
  }
};

// Generate time card report
export const generateTimeCardReport = async (reportData) => {
  try {
    console.log("Report data to be sent:", reportData);
    
    const response = await axios.post(
      `${Base_URL}/DailyTimecard/GetTimecardsByResourceId`,
      {
        resourceId: reportData.ResourceCode,
        fromDate: reportData.FromDate || null,
        toDate: reportData.ToDate || null
      }
    );
    
    // Transform the API response to match our expected format
    const transformedData = response.data.data.map(item => ({
      DTId: item.dtid,
      ResourceCode: item.resourceCode,
      UserName: item.userName,
      Date: item.date.split('T')[0], // Extract just the date part
      ProjectCode: item.projectCode,
      Hours: item.hours,
      Task: item.tasks,
      Remarks: item.remarks,
      Location: item.location,
      Status: item.status,
      CreatedBy: item.createdBy
    }));
    
    return {
      ...response.data,
      data: transformedData
    };
  } catch (error) {
    throw error.response?.data || "Error generating time card report!";
  }
};